import { BurgerOrder } from '../types';

// Demo режимд ашиглах mock өгөгдлийн сан
class MockDataService {
  private orders: BurgerOrder[] = [];
  private orderIdCounter = 1;

  // Захиалга хадгалах
  async saveOrder(order: Omit<BurgerOrder, 'id'>): Promise<BurgerOrder> {
    const newOrder: BurgerOrder = {
      ...order,
      id: `demo-order-${this.orderIdCounter++}`
    };
    
    this.orders.push(newOrder);
    
    // Local storage-д хадгалах
    localStorage.setItem('burger-ai-orders', JSON.stringify(this.orders));
    
    return newOrder;
  }

  // Хэрэглэгчийн захиалгуудыг авах
  async getUserOrders(userEmail: string): Promise<BurgerOrder[]> {
    // Local storage-оос унших
    const savedOrders = localStorage.getItem('burger-ai-orders');
    if (savedOrders) {
      this.orders = JSON.parse(savedOrders);
    }
    
    return this.orders
      .filter(order => order.customerEmail === userEmail)
      .sort((a, b) => new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime());
  }

  // Бүх захиалгуудыг авах (админ)
  async getAllOrders(): Promise<BurgerOrder[]> {
    const savedOrders = localStorage.getItem('burger-ai-orders');
    if (savedOrders) {
      this.orders = JSON.parse(savedOrders);
    }
    
    return this.orders.sort((a, b) => new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime());
  }

  // Захиалгын статус өөрчлөх
  async updateOrderStatus(orderId: string, status: string): Promise<void> {
    const savedOrders = localStorage.getItem('burger-ai-orders');
    if (savedOrders) {
      this.orders = JSON.parse(savedOrders);
    }
    
    const orderIndex = this.orders.findIndex(order => order.id === orderId);
    if (orderIndex !== -1) {
      this.orders[orderIndex].status = status as any;
      localStorage.setItem('burger-ai-orders', JSON.stringify(this.orders));
    }
  }

  // Demo өгөгдөл үүсгэх
  initializeDemoData() {
    const existingOrders = localStorage.getItem('burger-ai-orders');
    if (!existingOrders) {
      const demoOrders: BurgerOrder[] = [
        {
          id: 'demo-order-1',
          ingredients: [
            { id: 'bread1', name: 'Classic Bun', nameMn: 'Ердийн талх', price: 500, category: 'bread' },
            { id: 'meat1', name: 'Beef Patty', nameMn: 'Үхрийн мах', price: 2500, category: 'meat' },
            { id: 'cheese1', name: 'Cheddar', nameMn: 'Чеддар бяслаг', price: 600, category: 'cheese' }
          ],
          totalPrice: 3600,
          customerEmail: 'demo@burger.mn',
          customerName: 'Demo хэрэглэгч',
          customerPhone: '99112233',
          deliveryAddress: 'Улаанбаатар хот, 1-р хороо',
          status: 'delivered',
          orderDate: new Date(Date.now() - 24 * 60 * 60 * 1000) // 1 өдрийн өмнө
        },
        {
          id: 'demo-order-2',
          ingredients: [
            { id: 'bread2', name: 'Sesame Bun', nameMn: 'Кунжуттай талх', price: 700, category: 'bread' },
            { id: 'meat3', name: 'Double Beef', nameMn: 'Хос үхрийн мах', price: 4000, category: 'meat' },
            { id: 'veg1', name: 'Lettuce', nameMn: 'Салат ногоо', price: 300, category: 'vegetable' },
            { id: 'sauce1', name: 'Ketchup', nameMn: 'Кетчуп', price: 100, category: 'sauce' }
          ],
          totalPrice: 5100,
          customerEmail: 'admin@gmail.com',
          customerName: 'Admin Тест',
          customerPhone: '88776655',
          deliveryAddress: 'Улаанбаатар хот, 2-р хороо',
          status: 'ready',
          orderDate: new Date(Date.now() - 2 * 60 * 60 * 1000) // 2 цагийн өмнө
        },
        {
          id: 'demo-order-3',
          ingredients: [
            { id: 'bread1', name: 'Classic Bun', nameMn: 'Ердийн талх', price: 500, category: 'bread' },
            { id: 'meat2', name: 'Chicken Patty', nameMn: 'Тахианы мах', price: 2000, category: 'meat' },
            { id: 'veg2', name: 'Tomato', nameMn: 'Улаан лооль', price: 400, category: 'vegetable' }
          ],
          totalPrice: 2900,
          customerEmail: 'admin@gmail.com',
          customerName: 'Admin Тест',
          customerPhone: '88776655',
          deliveryAddress: 'Улаанбаатар хот, 3-р хороо',
          status: 'preparing',
          orderDate: new Date(Date.now() - 30 * 60 * 1000) // 30 минутын өмнө
        }
      ];
      
      localStorage.setItem('burger-ai-orders', JSON.stringify(demoOrders));
      this.orders = demoOrders;
    }
  }
}

export const mockDataService = new MockDataService();
